import type { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import { defaultThemeProp } from '../../theme';
import type { ForwardProps } from '../../types';

export const markStyles = ({ theme }: { theme: DefaultTheme }) => css`
  color: ${theme.base.colors.black};
  background-color: ${theme.components.mark['background-color']};
  font-weight: ${theme.components.mark['font-weight']};
`;

export const StyledMark = styled.mark`
  ${markStyles}
`;

StyledMark.defaultProps = defaultThemeProp;

const Mark: FunctionComponent<ForwardProps> = props => {
  return <StyledMark {...props} />;
};

export default Mark;
